<script>
import { IconChevronDown } from "@/components/icons/index";
import { BButton } from "bootstrap-vue";
import { globalHelper } from "@/helpers/index";

/**
 * TODO: CATCH INVALID UPLOADS AND DISPLAY ERROR MESSAGE
 * 1. More than one
 * 2. Corrupted or config
 * 3. Non-image
 * 4. More than specified size (3mb)
 * 5. Invalid format
 */
export default {
    components: {
        IconChevronDown,
        BButton,
    },

    props: {
        photos: { type: Array, default: () => [] },
        disabled: { type: Boolean, default: false },
        maximumPhoto: { type: Number, default: 10 },
        imgClass: { type: String, default: null },
    },

    data() {
        return {
            images: [],
            imageFile: "",
            imageName: "",
        };
    },

    watch: {
        photos(val) {
            this.images = val;
            this.initializeImage();
        },
    },

    methods: {
        scrollToTop() {
            globalHelper.scrollToTop();
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            const imageSizeLimit = 2000000; /** 2 mb */

            for (let index = 0; index < files.length; index++) {
                // console.log(
                //     files[index].type,
                //     files[index].name,
                //     files[index].size,
                //     files[index].type.includes("jpeg"),
                //     files[index].type.includes("png"),
                //     files[index].type.includes("jpeg") ||
                //         files[index].type.includes("png")
                // );
                /** Skips image > 2 mb  and unsupported image (jpg, png)*/
                if (
                    files[index].size <= imageSizeLimit &&
                    (files[index].type.includes("jpeg") ||
                        files[index].type.includes("png"))
                ) {
                    if (this.images.length === this.maximumPhoto) {
                        break; /** Limit maximum number */
                    }
                    this.images.push(files[index]);
                } else {
                    let errorMessage = "";
                    if (files[index].size > imageSizeLimit) {
                    }
                    errorMessage = "Image must not exceed 2 megabyte.";
                    if (
                        !(
                            files[index].type.includes("jpeg") ||
                            files[index].type.includes("png")
                        )
                    )
                        errorMessage = "Unsupported image type.";

                    this.$store.commit("alert/setAutoClose", false);
                    this.$store.commit("alert/error", errorMessage);
                    this.$store.commit("alert/setAutoClose", true);
                    this.scrollToTop();

                    break;
                }
            }
            this.initializeImage();
        },

        initializeImage() {
            for (let index = 0; index < this.images.length; index++) {
                this.createImage(index);
            }
            this.$emit("upload", this.images);
        },

        createImage(index) {
            let reader = new FileReader(); //instantiate a new file reader
            reader.addEventListener(
                "load",
                function () {
                    this.$refs["image" + parseInt(index)][0].src =
                        reader.result;
                }.bind(this),
                false
            ); //add event listener

            reader.readAsDataURL(this.images[index]);
        },

        removeImage(key) {
            this.images = this.images.filter((image, index) => index !== key);
            this.initializeImage();
        },
    },
};
</script>

<template>
    <div>
        <div
            class="upload-box"
            @drop.prevent="onFileChange"
            @dragenter.prevent
            @dragover.prevent
            @click="$refs.input.click()"
            :class="{
                'pe-none opacity-75': disabled,
            }"
        >
            <input
                ref="input"
                type="file"
                accept="image/png, image/jpeg"
                class="d-none"
                @change="onFileChange"
                multiple
            />
            <div v-if="images.length > 0" class="me-auto d-flex flex-wrap">
                <div
                    v-for="(image, index) in images"
                    :key="index"
                    class="image-container position-relative"
                    :style="{
                        width: '97px',
                        height: '97px',
                        borderRadius: '10px',
                    }"
                >
                    <div class="image-overlay rounded"></div>
                    <img
                        v-bind:ref="'image' + parseInt(index)"
                        alt=""
                        style="width: 100%; height: 100%; object-fit: cover"
                        class="rounded"
                    />
                    <!-- :src="image.photo_url || null" -->
                    <div
                        class="position-absolute start-0 top-0 h-100 w-100 d-flex justify-content-center align-items-center"
                    >
                        <b-button
                            variant="primary"
                            class="button-remove"
                            size="sm"
                            @click.stop="removeImage(index)"
                        >
                            Delete
                        </b-button>
                    </div>
                </div>
            </div>
            <div v-else class="text-center">
                <img
                    src="/assets/images/icons/upload.png"
                    alt="upload icon"
                    width="68px"
                    height="68px"
                />
                <p
                    class="mt-3 mb-0 font-size-14 fw-medium"
                    :style="{ color: '#74788D' }"
                >
                    Drop files here or click to upload.
                </p>
            </div>
        </div>

        <!-- <div class="invalid-feedback d-block mt-2">
      You can only upload files in image format.
    </div> -->
    </div>
</template>

<style lang="scss" scoped>
.upload-box {
    min-height: 160px;
    width: 100%;
    padding: 30px;
    border: 2px dashed #ced4da;
    background: #ffffff;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    .image {
        &-container {
            .button-remove {
                display: none;
            }
            &:hover {
                .image-overlay {
                    display: block;
                    background: rgba(0, 0, 0, 0.3);
                }
                .button-remove {
                    display: block;
                }
            }
        }
        &-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0);
            transition: background 0.5s ease;
        }
    }
    .d-flex.flex-wrap {
        gap: 20px;
    }
}
</style>
